import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as _Warning } from 'Images/warning-delete.svg';
import { slideIn, spinner } from 'Styles/effects';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';

export const ModalContent = styled.div`
  padding: 34px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  border-top: 10px solid ${colors.softBlue};
  background: ${({ theme }) => theme.backgrounds.modal};
  width: 505px;
  ${slideIn}
`;

export const ModalTitle = styled.div`
  display: flex;
  margin-bottom: 21px;
`;

export const Warning = styled(_Warning)`
  path {
    fill: ${({ theme }) => theme.text.modalTitle2};
  }
  align-self: center;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.text.modalTitle2};
  font-weight: 600;
  font-size: 21.5px;
  margin-left: 13px;
`;

export const ModalBody = styled.div`
  text-align: left;
`;

export const BodyText = styled.div`
  color: ${colors.grey19};
  font-size: 12.5px;
  font-weight: 300;
  display: inline-block;
  text-align: left;
`;

export const VulnerabilityList = styled.ul`
  margin: 14px 0 0;
  padding-left: 18px;
  max-height: 140px;
  overflow-y: auto;
`;

export const VulnerabilityItem = styled.li`
  color: ${colors.grey19};
  font-size: 12.5px;
  line-height: 1.5;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 34px;
`;

export const ConfirmButton = styled(Button)`
  ${({ $isLoading }) => $isLoading && spinner({ diameter: '15px' })};
`;

export const CancelButton = styled(BaseCancelButton)`
  margin-right: 10px;
`;
